/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_AnalysisInputs */

const en_document_analysis = /** @type {(inputs: Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Analysis`)
};

const nl_document_analysis = /** @type {(inputs: Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentanalyse`)
};

/**
* | output |
* | --- |
* | "Document Analysis" |
*
* @param {Document_AnalysisInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const document_analysis = /** @type {((inputs?: Document_AnalysisInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_AnalysisInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_document_analysis(inputs)
	return en_document_analysis(inputs)
});